import axios, {AxiosRequestConfig, AxiosResponse} from "axios";
import {getCachedToken} from "../utils/authUtils";
import {ENV} from "../utils/env";


const axiosClient = axios.create({
    baseURL: new URL(ENV.REACT_APP_API_POINT!, ENV.REACT_APP_API_HOST).toString(),
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

axiosClient.interceptors.request.use((req) => {
    const token = getCachedToken();

    if (token && req.headers) {
        req.headers['Authorization'] = `Bearer ${token?.accessToken}`;
    }
    return req;
});

axiosClient.interceptors.response.use(
    function (response: AxiosResponse) {
        return response;
    },
    function (error) {
        if (error?.response?.status === 401) {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userName');
            window.location.href = '/'

            // JMIX (Cuba) always returns 401 on logout request (/oauth/revoke) => reject is replaced by resolve
            return Promise.resolve(error);
        }
        return Promise.reject(error);
    }
);

export default axiosClient;